import InputSenha from "../Componets/InputSenha";
import iconCriarSenha from "../imagem/iconTelaDePrimeiroAcesso.svg";
import iconConexaoLiteraria from "../imagem/iconConexaoLiteraria.svg";
import iconInstitutoYouX from "../imagem/institutoYouX.svg";
import "./CriarSenha.css";
import { useNavigate, useParams } from "react-router-dom";
import { mandarSenha, pegarRefAluno } from "../services/api";
import { useEffect, useState } from "react";

export function CriarSenha() {
  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [aviso, setAviso] = useState("*Mínimo 8 caracteres.");
  const navigate = useNavigate();
  const { hash } = useParams();

  async function verificarSenha() {
    try {
      if (senha.length < 8) {
        setAviso("Sua senha deve ter no mínimo 8 caracteres.");
        return;
      }
      if (confirmarSenha !== senha) {
        setAviso("Por favor, digite a mesma senha nos dois campos.");
        return;
      }
      setSenha("");
      setConfirmarSenha("");
      await mandarSenha(hash, senha);
      navigate("/login");
    } catch (error) {
      console.log("erro ao mandar a senha :>> ", error);
    }
  }
  return (
    <div className="container_criarSenha">
      <div className="form">
        <img
          src={iconConexaoLiteraria}
          alt="conexao_literaria"
          className="logo_conexao"
        />
        <h3>Criar senha de acesso</h3>
        <label>Nova senha</label>
        <InputSenha
          placeholder=""
          changeValue={setSenha}
          value={senha}
          className="inputSenha"
        />
        <label>Confirmar nova senha</label>
        <InputSenha
          placeholder=""
          changeValue={setConfirmarSenha}
          value={confirmarSenha}
          className="inputSenha"
        />
        <p>{aviso}</p>
        <button className="btnConfirmar" onClick={verificarSenha}>
          Confirmar
        </button>
        <div className="instituto_span">
          <span>Desenvolvido pelo</span>{" "}
          <img src={iconInstitutoYouX} alt="instituto_icon" />
        </div>
      </div>
      <div className="caixa_img_criarSenha">
        <img src={iconCriarSenha} alt="img_criarSenha" />
      </div>
    </div>
  );
}
